import { useSelector } from 'react-redux';
import { isExperimentActive, getParameter } from '../../store/experiments/selectors';
import { ExperimentKeys } from '../ExperimentKeys';
import { EventName } from '../../tracking/EventName';
import { getTracker } from '../../tracking/getTracker';
import { getHasExposureBeenTracked, setHasExposureBeenTracked } from '../useExperiment';
const checkExperimentACQ145Active = state => {
  return isExperimentActive(state, ExperimentKeys.ACQ0145);
};
const checkExperimentACQ145Parameter = state => {
  return getParameter(state, ExperimentKeys.ACQ0145);
};
export const useShouldTrackACQ145 = () => {
  const shouldTrackExposure = useSelector(checkExperimentACQ145Active);
  const parameter = useSelector(checkExperimentACQ145Parameter);
  const trackACQ145Exposure = () => {
    const hasExposureBeenTracked = getHasExposureBeenTracked(ExperimentKeys.ACQ0145);
    if (shouldTrackExposure && !hasExposureBeenTracked) {
      getTracker().track(EventName.ExperimentExposure, {
        action: `${ExperimentKeys.ACQ0145}-group-${parameter}`
      }, true);
      setHasExposureBeenTracked(ExperimentKeys.ACQ0145);
    }
  };
  return {
    trackACQ145Exposure
  };
};
export const trackAcq145ExposureForGooglePrompt = state => {
  const shouldTrackExposure = checkExperimentACQ145Active(state);
  const parameter = checkExperimentACQ145Parameter(state);
  const hasExposureBeenTracked = getHasExposureBeenTracked(ExperimentKeys.ACQ0145);
  if (shouldTrackExposure && !hasExposureBeenTracked) {
    getTracker().track(EventName.ExperimentExposure, {
      action: `${ExperimentKeys.ACQ0145}-group-${parameter}`
    }, true);
    setHasExposureBeenTracked(ExperimentKeys.ACQ0145);
  }
};